<template>
  <v-col
    cols="12"
    lg="5"
  >
    <p class="add-rx-items-details-sub-title margin-bottom-4">
      # of empty bottles
    </p>
    <div>
      <v-row class="rx-items-row-margin">
        <v-col
          cols="12"
          lg="4"
          class="rx-item-border-1px rx-items-controls-symbols"
        >
          <button
            class="width-100p"
            @click="decreaseContainers()"
            :disabled="noOfEmptyBottles == 1 || !rxApprovalData.id"
          >
            <img src="src/assets/images/minus-outline-icon.svg">
          </button>
        </v-col>
        <v-col
          cols="12"
          lg="4"
          class="rx-item-border-1px rx-items-controls-values"
        >
          <input
            type="text"
            v-model="noOfEmptyBottles"
            class="rx-items-controls-input"
            name="quantity"
            maxlength="4"
            readonly
            @click="checkDialog('numeric','noOfEmptyBottles','# of empty bottles',
                                contentIndex, noOfEmptyBottles.toString())"
          >
        </v-col>
        <v-col
          cols="12"
          lg="4"
          class="rx-item-border-1px rx-items-controls-symbols"
        >
          <button
            class="width-100p"
            @click="increaseContainers()"
            :disabled="!rxApprovalData.id"
          >
            <img
              src="src/assets/images/plus-outline-icon.svg"
              class="margin-top-10"
            >
          </button>
        </v-col>
      </v-row>
    </div>
    <KeyboardDialog
      :open-dialog="pinDialogIsOpen"
      :keyboard-type="keyBoardType"
      :model-name="modelName"
      :label-name="labelName"
      :model-value="modelValue"
      @dialogInputChanged="dialogInputChanges"
      name="keyboard"
      @enterClicked="enterClicked"
    />
  </v-col>
</template>
<script>
import { mapGetters } from 'vuex';
import KeyboardDialog from '../virtual-keyboard/virtualKeyboardDialog.vue';

export default {
  name: 'EmptyBottleContainer',
  components: {
    KeyboardDialog,
  },
  computed: {
    ...mapGetters({
      rxApprovalData: 'rxApproval/getRxApprovalDetail',
    }),
  },
  data() {
    return {
      pinDialogIsOpen: false,
      keyBoardType: '',
      modelName: '',
      labelName: '',
      modelValue: '',
    };
  },
  methods: {
    increaseContainers() {
      this.$store.commit('rxContent/increaseContent', {
        index: this.contentIndex,
        field: 'noOfEmptyBottles',
      });
    },
    decreaseContainers() {
      this.$store.commit('rxContent/decreaseContent', {
        index: this.contentIndex,
        field: 'noOfEmptyBottles',
      });
    },
    checkDialog(KeyboardType, modelName, labelName, index, modelValue) {
      if (this.rxApprovalData.id) {
        this.pinDialogIsOpen = true;
        this.keyBoardType = KeyboardType;
        this.modelName = modelName;
        this.labelName = labelName;
        this.keypadIndex = index;
        this.modelValue = modelValue;
      }
    },
    dialogInputChanges(changes) {
      this.pinDialogIsOpen = changes;
    },
    enterClicked(value) {
      const model = value.modelName;
      this.$store.commit('rxContent/setContentValue', {
        index: this.contentIndex,
        field: model,
        value: +value.input,
      });
    },

  },
  props: {

    noOfEmptyBottles: {
      type: Number,
      default: 1,
    },
    contentIndex: {
      type: Number,
      default: 0,
    },
  },
};
</script>
